export const IconEditWrite = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clipPath="url(#clip0_2469_37053)">
      <path
        d="M8.73547 9.63305L5.85547 10.1414L6.36379 7.26137L11.83 1.80809C11.9188 1.71909 12.0243 1.64849 12.1405
        1.60031C12.2566 1.55214 12.3811 1.52734 12.5068 1.52734C12.6326 1.52734 12.7571 1.55214 12.8732
         1.60031C12.9893 1.64849 13.0948 1.71909 13.1836 1.80809L14.1988 2.82329C14.2878 2.9121 14.3584
          3.0176 14.4066 3.13373C14.4548 3.24987 14.4796 3.37436 14.4796 3.50009C14.4796 3.62582 14.4548
           3.75031 14.4066 3.86645C14.3584 3.98258 14.2878 4.08808 14.1988 4.17689L8.73547 9.63305Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0395 10.4725V13.472C13.0395 13.6055 13.013 13.7377 12.9616 13.8608C12.9101 13.984 12.8347 14.0957
         12.7397 14.1894C12.6447 14.2832 12.5321 14.3572 12.4083 14.4071C12.2845 14.457 12.152 14.4818 12.0186
          14.48H2.54049C2.40703 14.4818 2.27456 14.457 2.15077 14.4071C2.02697 14.3572 1.91431 14.2832 1.81933
           14.1894C1.72436 14.0957 1.64895 13.984 1.59748 13.8608C1.54602 13.7377 1.51952 13.6055 1.51953
            13.472V3.96804C1.51952 3.83457 1.54602 3.70243 1.59748 3.57928C1.64895 3.45613 1.72436 3.34443
             1.81933 3.25066C1.91431 3.15689 2.02697 3.08291 2.15077 3.03302C2.27456 2.98313 2.40703 2.95833
              2.54049 2.96004H5.60193"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2469_37053">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
